import z from "zod";

const zNumberOfRoomsSchema = z
  .number()
  .int()
  .positive()
  .max(2 ** 8)
  .brand("NumberOfRooms");
type NumberOfRoomsSchema = z.infer<typeof zNumberOfRoomsSchema>;

export { zNumberOfRoomsSchema };
export type { NumberOfRoomsSchema as NumberOfRooms, NumberOfRoomsSchema };
